__turbopack_context__.v({
  "nonFocusableOutline": "Popup-module__-N7G3G__nonFocusableOutline",
  "popupContainer": "Popup-module__-N7G3G__popupContainer",
  "spyElement": "Popup-module__-N7G3G__spyElement",
});
